<template>
  <header class="landing-header">
    <div class="background-fill"></div>
    <div class="header-wrapper">
      <div class="autodesk-logo-parent" @click="navigateHome()">
        <div class="autodesk-logo"></div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "simple-header",
  computed: {},
};
</script>
<style scoped>
.background-fill {
  background: #000000;
  width: 100%;
  height: 60px;
  position: absolute;
}

.autodesk-logo {
  width: 160px;
  height: 60px;
  background: url(../assets/image/home_page/employeehub-logo.svg) center
    center no-repeat;
  margin-top: 0;
  background-size: contain;
}
.autodesk-logo-parent {
  float: left;
  padding: 0 10px;
  line-height: 60px;
  color: #373435;
  font-size: 45px;
  cursor: pointer;
  text-transform: uppercase;
  position: absolute;
}
.header-wrapper {
  padding-left: 15px;
  padding-right: 15px;
}
.landing-header {
  height: 60px;
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/SimpleHeader.vue